import { useQuery } from '@apollo/client';
import { GET_PROCESS_AREAS_IT_APPLICATION_SUMMARY } from '../graphql';
import type {
  GetProcessAreasItApplicationSummaryData,
  GetProcessAreasItApplicationSummaryVars,
} from '../types';

/**
 * Hook to fetch process areas it application summary
 * @param locationUUID - The UUID of the location to fetch the data for. This parameter is required.
 * @returns {{ data: ProcessAreasSummary, loading: boolean, error: ApolloError }}
 */
export const useProcessAreasItAppSummary = (locationUUID: string) => {
  const result = useQuery<
    GetProcessAreasItApplicationSummaryData,
    GetProcessAreasItApplicationSummaryVars
  >(GET_PROCESS_AREAS_IT_APPLICATION_SUMMARY, {
    variables: { locationUUID },
    skip: !locationUUID, // Skip the query if locationUUID is not provided
  });

  // Debug logging
  if (result.error) {
    console.error('useProcessAreasItAppSummary GraphQL error:', result.error);
  }

  return {
    data: result.data?.getProcessAreaItApplicationSummary,
    loading: result.loading,
    error: result.error,
  };
};
